<div class="calendar-picker-container">
    <img class="calendar-icon" src="../../../../../assets/icons/new-service-calendar.svg" alt="Calendar icon" />
    <!-- <input type="text" #dateInput class="add-vehicle-info-input" #dp="bsDatepicker" bsDatepicker [daysDisabled]="[6, 0]"
        [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' }" autocomplete="off" [ngClass]="{
        'error-color':
          dateError
      }" placeholder="DD / MM / YYYY"  /> -->
    <input type="text" #dateInput class="add-vehicle-info-input" bsDatepicker [(ngModel)]="dateParsed"
        (ngModelChange)="dateValueEmit($event)" [daysDisabled]="[6, 0]" [bsConfig]="bsConfig" autocomplete="off"
        [ngClass]="{ 'error-color': dateError }" placeholder="DD / MM / YYYY" />

</div>
<!-- <div style="height: 50px; border: 1px solid red">
    <p-calendar [(ngModel)]="dateValueParse" selectionMode="range" [dateFormat]="'dd/mm/yy'" [readonlyInput]="true"
        [firstDayOfWeek]="1" [disabledDays]="[6, 0]" />
</div> -->